import { Component } from '@angular/core';

@Component({
  selector: 'app-roster-quick-group-add',
  templateUrl: './roster-quick-group-add.component.html',
  styleUrls: ['./roster-quick-group-add.component.scss']
})
export class RosterQuickGroupAddComponent {
  selectedGroupType: 'single' | 'multi' = 'single';

  onGroupTypeChange(value: 'single' | 'multi') {
    this.selectedGroupType = value;
  }
}
